// extracted by mini-css-extract-plugin
export default {"user":"User_user__rfNvF","userName":"User_userName__Zg332","rate":"User_rate__Mvwp8"};